'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Helpers from '../_helpers';
/**
 * YouTube class
 *
 * @type class
 */
export default class YouTube {
    /**
     * Constructor
     *
     * @param Config_Interface
     */
    constructor(config) {
        /**
         * Helper
         *
         * @type Helpers
         */
        this.helpers = new Helpers;
        this._config = config;
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        /**
         * Build YouTube video array
         *
         */
        window.onYouTubeIframeAPIReady = () => {
            document.querySelectorAll('iframe[src^="https://www.youtube"]').forEach((iframe) => {
                // Add ?enablejsapi=1 to iframe src
                const url = new URL(iframe.src);
                url.searchParams.set('enablejsapi', '1');
                iframe.src = url.href;
                window.rddl.yt.push({
                    player: new window.YT.Player(iframe),
                    played: false
                });
            });
        };
    }
    /**
     * Video start
     *
     * @param   object dataLayer
     */
    start(dataLayer) {
        (() => __awaiter(this, void 0, void 0, function* () {
            while (window.rddl.yt.length == 0)
                yield new Promise(resolve => setTimeout(resolve, 500));
            window.rddl.yt.forEach((yt) => {
                yt['player'].addEventListener('onStateChange', (event) => {
                    // Start only
                    if (event.data && yt['played'] === false) {
                        yt['played'] = true;
                        let custom_model = {
                            'event': '',
                            'title': yt['player'].getVideoData().title,
                            'id': yt['player'].getVideoData().video_id,
                            'url': yt['player'].getVideoUrl(),
                            'duration': yt['player'].getDuration(),
                        };
                        // Check and push dataLayer object reference against custom model
                        window.dataLayer.push(this.helpers.process_datalayer(dataLayer, { youtube: custom_model }));
                    }
                });
            });
        }))();
    }
    /**
     * Video end
     *
     * @param  object dataLayer
     */
    end(dataLayer) {
        (() => __awaiter(this, void 0, void 0, function* () {
            while (window.rddl.yt.length == 0)
                yield new Promise(resolve => setTimeout(resolve, 500));
            window.rddl.yt.forEach((yt) => {
                yt['player'].addEventListener('onStateChange', (event) => {
                    if (event.data === 0) {
                        yt['played'] = true;
                        let custom_model = {
                            'event': '',
                            'title': yt['player'].getVideoData().title,
                            'id': yt['player'].getVideoData().video_id,
                            'url': yt['player'].getVideoUrl(),
                            'duration': yt['player'].getDuration(),
                        };
                        // Check and push dataLayer object reference against custom model
                        window.dataLayer.push(this.helpers.process_datalayer(dataLayer, { youtube: custom_model }));
                    }
                });
            });
        }))();
    }
}
